import resolveFeatureFlag from './resolveFeatureFlag';

/**
 * The nav bar's Blocks/Dimensions/Data hover dropdowns (NavigationBar.tsx)
 * are gated by two real LaunchDarkly flags — `blockDimDropdown` and
 * `dataImportDropdown`. If LD doesn't have them enabled for the current
 * user/environment, the arrows and hover menus simply don't render; nothing
 * in this codebase was wiping them, LD just has no opinion for this context.
 *
 *   localStorage.setItem('blockDimDropdown', 'false')
 *   localStorage.setItem('dataImportDropdown', 'false')
 *   localStorage.removeItem('blockDimDropdown')   // back to default (on)
 *   localStorage.removeItem('dataImportDropdown')
 */
export const isBlockDimDropdownEnabled = (flags?: { blockDimDropdown?: boolean }): boolean =>
  resolveFeatureFlag('blockDimDropdown', flags?.blockDimDropdown);

export const isDataImportDropdownEnabled = (flags?: { dataImportDropdown?: boolean }): boolean =>
  resolveFeatureFlag('dataImportDropdown', flags?.dataImportDropdown);
